import type { CardType, CreatureKind, TerritoryCategory } from '../types/catalog';
import { CARD_TYPE_LABEL, CREATURE_KIND_LABEL, TERRITORY_CATEGORY } from '../i18n/labels';

/** Selo do tipo de carta, colorido por tipo. */
export function TypeBadge({ type }: { type: CardType }): React.JSX.Element {
  return <span className={`badge type-${type}`}>{CARD_TYPE_LABEL[type]}</span>;
}

/** Custo de energia da carta. */
export function EnergyBadge({ cost }: { cost: number }): React.JSX.Element {
  return (
    <span className="energy" title={`Custo de energia: ${cost}`} aria-label={`Custo ${cost}`}>
      {cost}
    </span>
  );
}

/** Ataque base de uma unidade. */
export function AttackBadge({ attack }: { attack: number }): React.JSX.Element {
  return (
    <span className="attack" title={`Ataque base: ${attack}`} aria-label={`Ataque ${attack}`}>
      {attack}
    </span>
  );
}

/** Tag de criatura (gado, felina, …). */
export function KindBadge({ kind }: { kind: CreatureKind }): React.JSX.Element {
  return <span className="badge">{CREATURE_KIND_LABEL[kind]}</span>;
}

/** Selo da categoria de território (leve / médio / pesado). */
export function CategoryBadge({ category }: { category: TerritoryCategory }): React.JSX.Element {
  const meta = TERRITORY_CATEGORY[category];
  return (
    <span className="badge" title={meta.help} style={{ color: meta.color, borderColor: meta.color }}>
      <span className="badge-dot" style={{ background: meta.color }} aria-hidden />
      {meta.label}
    </span>
  );
}
